import { serviceRequest } from './service-request';

export function reportReferral() {
	return serviceRequest('svc/referrals/report-referral', {
		referringUrl: document.referrer,
		destinationUrl: location.href
	});
}